import React from 'react';
import { translate } from 'react-i18next';
import { ratingLabel, ratingStyle } from './vrfSeerRating';

// FRS 4.2.1 Phase 5 - ป้ายระดับประสิทธิภาพ SEER ตามเกณฑ์ กฟผ.
const VRFSeerBadge = ({ code, t }) => {
  if (!code) return <span>-</span>;
  return <span style={ratingStyle(code)}>{ratingLabel(code, t)}</span>;
};

export default translate('translations')(VRFSeerBadge);



// WEBPACK FOOTER //
// ./src/components/vrf/VRFSeerBadge.js